export default "__VITE_ASSET__DuT9fnkS__"